import React from 'react';
import { ICONS } from '../../v2-config/constants/icons.constant';
import './style.scss';
import ScrollToTop from '../../v2-components/ScrollToTop';


export default function LoadingPage() {
	return (
		<>
		<ScrollToTop />
		<div className="loading-page">
			<img src={ICONS.LOADING} alt={'Cargando...'} title={'Cargando...'} />
		</div>
		</>
	);
}
